import { Serializable } from './serializable';

export type ModalClosed = Promise<Serializable>;

type ModalParams = Record<string, any>;

export type ProviderOpenModal = (
  modalId: string,
  modalParams?: ModalParams,
) => { modalClosed: ModalClosed };

/** @deprecated */
type LegacyOpenModalArgs = [modalId: string, modalParams?: ModalParams];

export type OpenModal = (
  ...args:
    | [{ modalId: string; params?: ModalParams }, never?]
    | LegacyOpenModalArgs
) => {
  modalClosed: ModalClosed;
};

export type CloseModal = (closeData?: Serializable) => void;
